<script>
    import { executeClient } from "api/rage";
    export let closeMenu;
    export let selected;

    const stageText = (s) => {
        if (s === 4) return "Носите ящики из кучи в фургон (берите по E)";
        if (s === 5) return "Выносите ящики из фургона на точку (берите по E)";
        if (s === 3) return "Заберите выданный трейлер (отмечен на карте)";
        if (s === 2) return "Везите груз на точку выгрузки";
        if (s === 1) return "Идёт погрузка…";
        return "Двигайтесь к точке погрузки";
    };

    const onRoute = () => executeClient ("client.phone.trucker.route");
    const onCancel = () => {
        if (!window.loaderData.delay ("trucker.cancel", 2)) return;
        executeClient ("client.phone.trucker.cancel");
    }
</script>

<div class="mybizappmenuitem">
    <div class="mybizappmenuitem__item">
        <div class="headitem">
            <div class="leftitem"><div class="trkbig">{selected.cls===0?"🚐":"🚛"}</div></div>
            <div class="rightitem">
                <h1>{selected.title}</h1>
                <p>Активный контракт</p>
                <span>{selected.area}</span>
                <span class="trkstage">{stageText(selected.stage)}</span>
                <div class="iteminfo">
                    <p>${selected.reward}</p>
                    <span>Оплата по завершении</span>
                </div>
            </div>
        </div>
        <div class="btnsitem">
            <div class="btnsitem__item" on:keypress={()=>{}} on:click={onRoute}><p>Проложить маршрут</p></div>
            <div class="btnsitem__item trkcancel" on:keypress={()=>{}} on:click={onCancel}><p>Отменить</p></div>
        </div>
    </div>
</div>

<style>
    .trkbig { font-size:12vh; }
    .trkstage { color:#4fe0a0 !important; margin-top:.6vh; }
    .trkcancel { background:rgba(255,80,80,.12) !important; }
</style>
